var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.364 3.97026C14.5514 4.15779 14.6568 4.4121 14.6568 4.67726C14.6568 4.94243 14.5514 5.19673 14.364 5.38426L6.86864 12.8796C6.76959 12.9787 6.65199 13.0573 6.52256 13.1109C6.39313 13.1645 6.25441 13.1921 6.11431 13.1921C5.97421 13.1921 5.83549 13.1645 5.70606 13.1109C5.57663 13.0573 5.45903 12.9787 5.35998 12.8796L1.63598 9.15626C1.54047 9.06401 1.46428 8.95367 1.41188 8.83167C1.35947 8.70966 1.33188 8.57844 1.33073 8.44566C1.32957 8.31288 1.35487 8.1812 1.40516 8.05831C1.45544 7.93541 1.52969 7.82376 1.62358 7.72987C1.71747 7.63597 1.82913 7.56172 1.95202 7.51144C2.07492 7.46116 2.2066 7.43586 2.33938 7.43701C2.47216 7.43816 2.60338 7.46575 2.72538 7.51816C2.84739 7.57057 2.95773 7.64675 3.04998 7.74226L6.11398 10.8063L12.9493 3.97026C13.0422 3.87733 13.1524 3.80362 13.2738 3.75332C13.3952 3.70303 13.5253 3.67714 13.6566 3.67714C13.788 3.67714 13.9181 3.70303 14.0395 3.75332C14.1608 3.80362 14.2711 3.87733 14.364 3.97026Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/Checked.33f6467907d0199ca2c020eadb70c16b.svg";
export { ForwardRef as ReactComponent };